import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '../data/ColisContext';

export default function RequireAdmin({ children }) {
  const { user, authBooting } = useApp();
  const location = useLocation();

  if (authBooting) return null;

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!user?.is_admin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
